<form [formGroup]="dataRefreshForm" class="flex-layout no-wrap no-gap">
    <!-- Offset width to account for icon to the right -->
    <mat-form-field id="refresh-date-time-field" >
        <mat-label>Refresh Data Time</mat-label>
        <mat-select formControlName="refreshDataTimeSelectBox">
        <mat-option value="30">30 seconds</mat-option>
        <mat-option value="60">1 minute</mat-option>
        <mat-option value="300">5 minutes</mat-option>
        <mat-option value="900">15 minutes</mat-option>
        </mat-select>
    </mat-form-field>
    <button [title]="isLoadingData() ? 'Orders being retrieved' : ''" mat-icon-button class="item-grow" [disabled]="isLoadingData()" (click)="refreshData()">
        @if (!isLoadingData()) {
            <mat-icon>refresh</mat-icon>
        } @else {
            <mat-progress-spinner [diameter]="24" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
        }
    </button>
</form>